import { Position } from '@xyflow/react';
import { resolveAttackPathToolbarPosition } from './attack-path-node-toolbar-position.util';

const POPOVER_OFFSET = 12;
const VIEWPORT_MARGIN = 8;
const POPOVER_HALF_WIDTH = 120;

type NodeBounds = {
  top: number;
  bottom: number;
  left: number;
  width: number;
};

export type AttackPathPagePopoverAnchor = {
  left: number;
  top: number;
  position: Position;
};

export const resolveAttackPathPagePopoverAnchor = ({
  nodeBounds,
  viewport,
}: {
  nodeBounds: NodeBounds;
  viewport: { width: number; height: number };
}): AttackPathPagePopoverAnchor => {
  const position = resolveAttackPathToolbarPosition({
    nodeBounds,
    containerBounds: { top: 0, bottom: viewport.height },
  });
  const minLeft = VIEWPORT_MARGIN + POPOVER_HALF_WIDTH;
  const maxLeft = Math.max(
    minLeft,
    viewport.width - VIEWPORT_MARGIN - POPOVER_HALF_WIDTH,
  );
  const centerX = nodeBounds.left + nodeBounds.width / 2;

  return {
    left: Math.min(Math.max(centerX, minLeft), maxLeft),
    top:
      position === Position.Top
        ? nodeBounds.top - POPOVER_OFFSET
        : nodeBounds.bottom + POPOVER_OFFSET,
    position,
  };
};
